import { Download } from 'lucide-react'
import { ActionPopover } from './wrappers/ActionPopover'
import { DepositFundsContent } from './content/DepositFundsContent'

interface DepositFundsPopoverProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onMobileClick?: () => void
  isActive?: boolean
}

export function DepositFundsPopover({
  open,
  onOpenChange,
  onMobileClick,
  isActive,
}: DepositFundsPopoverProps) {
  return (
    <ActionPopover
      open={open}
      onOpenChange={onOpenChange}
      trigger={<Download className="w-8 h-8" />}
      onMobileClick={onMobileClick}
      isActive={isActive}
    >
      <DepositFundsContent />
    </ActionPopover>
  )
}
